import { BooleanFilterConfig } from '../types/filter-config';
import { FilterItemConfigOptions } from '../types/filter-item-config-options';
import { FilterStateFactoryRef } from './filter.function';
import { BooleanFilter } from '../types/filter';
import { QueryFilter } from '@softline/core';
import { BooleanFilterOperator } from '../types/filter-operators';
import { defaultFilterInputTypeFactory } from '../page-filter/helper/default-filter-input-type.factory';

export interface BooleanFilterOptions<T extends object> extends FilterItemConfigOptions<T, boolean> {
  defaultOperator?: BooleanFilterOperator;
  allowedOperators?: BooleanFilterOperator[];
}

export function booleanFilter<T extends object>(
  ref: FilterStateFactoryRef<T>,
  options: BooleanFilterOptions<T>): void {
  const config: BooleanFilterConfig<T> = {
    ...options,
    type: 'boolean',
    defaultOperator: options.defaultOperator ?? 'false',
    allowedOperators: options.allowedOperators ?? ['true', 'false'],
    formatter: options.formatter ?? ((o) => `${o}`),
    inputTypeFactory: defaultFilterInputTypeFactory,
    toQueryFilter,
  }
  ref.addItem(config);
}

function toQueryFilter<T extends object>(filter: BooleanFilter<T>): QueryFilter<T> {
  switch (filter.operator) {
    case 'true':
      return { name: filter.field, type: 'booleanIsTrue' }
    case 'false':
      return { name: filter.field, type: 'booleanIsFalse' }
  }
}
